<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="6"
    viewBox="0 0 8 4"
    fill="none"
  >
    <path d="M4 4L7.4641 0.25H0.535898L4 4Z" fill="#919191" />
  </svg>
</template>
